import script from "./UserEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditModal.vue?vue&type=script&setup=true&lang=js"

import "./UserEditModal.vue?vue&type=style&index=0&id=909185b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909185b6"]])

export default __exports__